import { isFunction } from './inspect.js';

/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types */

/**
 * Get normalized vue slot
 */
function getNormalizeSlot(name, props, $slots, $scopedSlots) {
  var slot = $scopedSlots[name] || $slots[name];
  return isFunction(slot) ? slot(props) : slot;
}

export { getNormalizeSlot };
